(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-email"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  var form  = document.getElementById('kw-email-form-{{ section.id }}');
  var input = document.getElementById('kw-email-input-{{ section.id }}');
  var error = document.getElementById('kw-email-error-{{ section.id }}');

  if (!form || !input) return;

  form.addEventListener('submit', function (e) {
    if (!input.validity.valid || input.value.trim() === '') {
      e.preventDefault();
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    } else {
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    }
  });

  input.addEventListener('input', function () {
    if (input.validity.valid) {
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    }
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-hero"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  // ── Pause ticker on hover (accessibility + UX) ──────────────
  document.querySelectorAll('.kw-ticker__track').forEach(function (track) {
    var ticker = track.closest('.kw-ticker');
    ticker.addEventListener('mouseenter', function () {
      track.style.animationPlayState = 'paused';
    });
    ticker.addEventListener('mouseleave', function () {
      track.style.animationPlayState = 'running';
    });
    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.style.animation = 'none';
    }
  });

  // ── Fade-in on scroll (Intersection Observer) ────────────────
  var hero = document.querySelector('.kw-hero');
  if (!hero) return;

  // Stagger the content children in on load
  var targets = hero.querySelectorAll(
    '.kw-hero__eyebrow, .kw-hero__heading, .kw-hero__sub, .kw-hero__btns, .kw-hero__trust'
  );

  targets.forEach(function (el, i) {
    el.style.opacity    = '0';
    el.style.transform  = 'translateY(16px)';
    el.style.transition =
      'opacity 0.6s ease ' + (i * 0.1 + 0.1) + 's, ' +
      'transform 0.6s ease ' + (i * 0.1 + 0.1) + 's';
  });

  // Trigger after a short delay so CSS has loaded
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      targets.forEach(function (el) {
        el.style.opacity   = '1';
        el.style.transform = 'translateY(0)';
      });
    });
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-how-it-works"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  var section = document.getElementById('kw-how-{{ section.id }}');
  if (!section) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Staggered entrance per step */
  var steps = section.querySelectorAll('.kw-how__step');

  steps.forEach(function (step) {
    step.style.opacity   = '0';
    step.style.transform = 'translateY(18px)';
    step.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var step  = entry.target;
        var index = Array.prototype.indexOf.call(steps, step);
        setTimeout(function () {
          step.style.opacity   = '1';
          step.style.transform = 'translateY(0)';
        }, index * 100);
        observer.unobserve(step);
      }
    });
  }, { threshold: 0.1 });

  steps.forEach(function (step) { observer.observe(step); });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-manifesto"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  var section = document.getElementById('kw-manifesto-{{ section.id }}');
  if (!section) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var left  = section.querySelector('.kw-manifesto__left');
  var right = section.querySelector('.kw-manifesto__right');

  [left, right].forEach(function (el, i) {
    if (!el) return;
    el.style.opacity   = '0';
    el.style.transform = i === 0 ? 'translateY(20px)' : 'translateY(28px)';
    el.style.transition = 'opacity 0.65s ease ' + (i * 0.1) + 's, transform 0.65s ease ' + (i * 0.1) + 's';
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity   = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  [left, right].forEach(function (el) { if (el) observer.observe(el); });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-products"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  /* Card entrance animation on scroll */
  var section = document.getElementById('kw-products-{{ section.id }}');
  if (!section) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cards = section.querySelectorAll('.kw-products__card');

  cards.forEach(function (card) {
    card.style.opacity   = '0';
    card.style.transform = 'translateY(20px)';
    card.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var card  = entry.target;
        var index = Array.prototype.indexOf.call(cards, card);
        setTimeout(function () {
          card.style.opacity   = '1';
          card.style.transform = 'translateY(0)';
        }, index * 80);
        observer.unobserve(card);
      }
    });
  }, { threshold: 0.12 });

  cards.forEach(function (card) { observer.observe(card); });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-science"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  var section = document.getElementById('kw-science-{{ section.id }}');
  if (!section) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Slide-in content panel on scroll */
  var content = section.querySelector('.kw-science__content');
  var visual  = section.querySelector('.kw-science__visual');

  [content, visual].forEach(function (el, i) {
    if (!el) return;
    el.style.opacity   = '0';
    el.style.transform = i === 0 ? 'translateX(24px)' : 'translateX(-24px)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity   = '1';
        entry.target.style.transform = 'translateX(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  [content, visual].forEach(function (el) {
    if (el) observer.observe(el);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-stats"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  /* Count-up animation when stats scroll into view */
  var section = document.getElementById('kw-stats-{{ section.id }}');
  if (!section) return;

  /* Respect prefers-reduced-motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var numbers = section.querySelectorAll('.kw-stats__number');
  var animated = false;

  function parseNumber(str) {
    /* Strip non-numeric except dot → get the numeric core */
    return parseFloat(str.replace(/[^0-9.]/g, '')) || 0;
  }

  function getSuffix(str) {
    /* Everything after the last digit or dot */
    return str.replace(/^[\d.,\s]+/, '');
  }

  function getPrefix(str) {
    /* Anything before the first digit */
    return str.match(/^[^0-9]*/)[0];
  }

  function animateStat(el, duration) {
    var original = el.textContent.trim();
    var target   = parseNumber(original);
    var prefix   = getPrefix(original);
    var suffix   = getSuffix(original);
    var start    = null;
    var isDecimal = original.indexOf('.') !== -1;

    if (target === 0) return;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      /* Ease out cubic */
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      el.textContent = prefix + (isDecimal ? current.toFixed(1) : Math.round(current)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = original; /* Restore exact original string */
    }

    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !animated) {
        animated = true;
        numbers.forEach(function (el, i) {
          setTimeout(function () {
            animateStat(el, 1200);
          }, i * 120);
        });
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  observer.observe(section);

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-testimonials"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  var section = document.getElementById('kw-testi-{{ section.id }}');
  if (!section) return;

  /* Animate rating bars when section enters viewport */
  var fills   = section.querySelectorAll('.kw-testi__bar-fill');
  var animated = false;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !animated) {
        animated = true;
        fills.forEach(function (fill, i) {
          var target = fill.dataset.width || '0';
          setTimeout(function () {
            fill.style.width = target + '%';
          }, i * 80);
        });
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  observer.observe(section);

  /* Card stagger entrance */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cards = section.querySelectorAll('.kw-testi__card');
  cards.forEach(function (card) {
    card.style.opacity   = '0';
    card.style.transform = 'translateY(16px)';
    card.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
  });

  var cardObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var card  = entry.target;
        var index = Array.prototype.indexOf.call(cards, card);
        setTimeout(function () {
          card.style.opacity   = '1';
          card.style.transform = 'translateY(0)';
        }, index * 80);
        cardObserver.unobserve(card);
      }
    });
  }, { threshold: 0.1 });

  cards.forEach(function (card) { cardObserver.observe(card); });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-vehicles"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  var section = document.getElementById('kw-vehicles-{{ section.id }}');
  if (!section) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cards = section.querySelectorAll('.kw-vehicles__card');
  cards.forEach(function (card) {
    card.style.opacity   = '0';
    card.style.transform = 'translateY(14px)';
    card.style.transition = 'opacity 0.5s ease, transform 0.5s ease, background 0.28s';
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var card  = entry.target;
        var index = Array.prototype.indexOf.call(cards, card);
        setTimeout(function () {
          card.style.opacity   = '1';
          card.style.transform = 'translateY(0)';
        }, index * 80);
        observer.unobserve(card);
      }
    });
  }, { threshold: 0.1 });

  cards.forEach(function (card) { observer.observe(card); });

})();


  } catch(e) { console.error(e); }
})();
})();
